// extracted by mini-css-extract-plugin
module.exports = {"container":"NoMoreData_container__38mqL"};